<template lang="pug">
  div.payment.payment-update
    e-modal(
    ref="modalForm"
    @confirm="sendForm()"
    @close="closeForm()"
    :title="$options.title()"
    saveBtnLabel="Сохранить"
    :hideDeleteButton="false"
    :autoHeight="true"
    )
      slot
        e-form(
        :formValidator="formValidator"
        :enablePerfectScrollbar="false"
        formClass="fix-elements-overflow-problem"
        )
          div.body
            div.col
              e-form-group(
              name="operation_day"
              inputType="calendar"
              label="Операционный день"
              :model="fields"
              tabView="tab1"
              :required="true"
              )

              e-form-group(
              name="pay_day"
              inputType="calendar"
              label="Дата оплаты"
              :model="fields"
              tabView="tab1"
              :required="true"
              )

              e-form-group(
              inputType="suggestion"
              name="billingAccountName"
              realName="billing_account_id"
              label="Лицевой счет"
              :model="fields"
              tabView="tab1"
              :required="true"
              :suggestionEndpoint="suggestionAccountsEndpoint"
              :transformSuggestions="transformAccountsSuggestions"
              @selectItem="selectAccountsItem"
              :minSuggestLen="2"
              placeholder="начните вводить номер..."
              )

              div(v-if="fields.billing_account_id").payer-info
                template(v-if="fields._legal_id")
                  p ИНН: {{fields._inn}}
                  p Адрес плательщика: {{fields._address}}
                template(v-else)
                  p ФИО плательщика: {{fields._fio}}
                  p Адрес плательщика: {{fields._address}}

              e-form-group(
              name="value"
              label="Сумма"
              :model="fields"
              tabView="tab1"
              validationRule="double"
              :required="true"
              )

              e-form-group(
              name="comment"
              label="Основание"
              :model="fields"
              tabView="tab1"
              )


</template>

<script>
  import paymentFormMixin from './mixins/payment-form'
  import {payment} from "../../api/api-endpoints"

  export default {
    mixins: [paymentFormMixin],
    title () {
      return 'Добавление платежа'
    },
    methods: {
      getUpdateOrCreateUrl () {
        return payment.createPayment()
      }
    }
  }
</script>
